<app-admin-toast></app-admin-toast>
<div class="padding-component">
    <app-header [title]="'Servicios'"></app-header>

    <mat-tab-group >
        <mat-tab label="Servicios"><app-services ></app-services></mat-tab>
        <mat-tab label="Checklist"><app-check-lists ></app-check-lists></mat-tab>
        <mat-tab label="Controles"><app-controls ></app-controls></mat-tab>
    </mat-tab-group>
</div>